module.exports = __webpack_public_path__ + "static/media/motoraceite.f3117505.pdf";